import { Serializable } from '../../../core/models/serializable';
import { CustomerBrandingAccessTokenStatus } from './customer-branding-access-token-status.enum';

export class CustomerBrandingAccessTokenFilterModel
  implements Serializable<CustomerBrandingAccessTokenFilterModel>
{
  fromObject(object: any): CustomerBrandingAccessTokenFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    return {
      StatusIds: this.statusIds,
      Customer: this.customer,
    };
  }

  public statusIds: CustomerBrandingAccessTokenStatus[];
  public customer: string;
}
